import React, { Component, Fragment } from 'react';
import Table from './DeviceTable/index';
import { csvColumns, tableColumns } from './constants';
import cx from 'classnames';
import styles from './styles.scss';
import ModuleExport from '../../ModuleExport';
import { shape, string, arrayOf, number, bool, func, objectOf } from 'prop-types';
import DeviceChart from './DeviceChart/index';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { defaultChartSelector } from '../../../helpers/defaultInfo';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { DEVICE_CATEGORY_CHART_ID } from '../../../helpers/constant';
import { getNumberOfChartAndTableInReport } from '../Report/helper';
import DeleteReportItemButton from '../../DeleteReportItem';
import { COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE, MIN_LENGTH_TRAFFIC_CHANNEL_DATA, SINGLE_PAGE_WEB_ANALYTICS_DATA } from '../../../helpers/constant';
import { deviceCategoryChartId, deviceCategoryId, deviceCategoryTableId } from '../../../pages/ReportBuilder/constants';

export const defaultDataType = get(defaultChartSelector, [DEVICE_CATEGORY_CHART_ID, 'type']);
export class DeviceCategory extends Component {
  static propTypes = {
    title: string,
    fileName: string,
    dropDownOptions: shape({
      label: string,
      value: string
    }),
    currentStep: string,
    selectionType: string,
    isCustomize: string,
    data: arrayOf(shape({
      deviceType: string,
      ads: number,
      adVisit: number,
      adUser: number,
    })),
    showInReportConfig: shape({
      deviceCategoryChart: bool,
      deviceCategoryTable: bool,
    }),
    countInReportConfig: shape({
      deviceCategoryChart: arrayOf(number),
      deviceCategoryTable: arrayOf(number),
    }),
    isCustomReport: bool,
    setChartSelector: func,
    deviceChartSelectors: arrayOf(objectOf(string)),
    pageNumber: number,
    tableSortSelector: shape({
      sortKey: string,
      sortType: string,
    }),
    setReportChartSelector: func,
    campaign: shape({}),
    classes: shape({}),
    inpdf: bool,
    page: number,
    totalAds: number,
    isHiddenChart: bool,
  }

  static defaultProps = {
    title: 'Device Category',
    fileName: 'device_category_analytics_chart',
    dropDownOptions: {
      adVisits: {
        label: 'Ad Visits',
        key: 'adVisits'
      },
    },
    currentStep: '',
    isCustomize: 'customize',
    data: [],
    showInReportConfig: {},
    countInReportConfig: {
      deviceCategoryChart: [1],
      deviceCategoryTable: [1],
    },
  }


  handleTypeChange = (selectorIndex, chartId) => (e) => {
    const {
      setChartSelector,
      campaign,
      setReportChartSelector,
      isCustomReport,
    } = this.props;
    const campaignId = campaign.campaign_id;
    const newType = e.target.value;
    setChartSelector &&
      setChartSelector(campaignId, chartId, { type: newType });
    isCustomReport &&
      setReportChartSelector &&
      setReportChartSelector(chartId, selectorIndex, {
        type: newType,
      });
  }

  drawDropDown(selectorIndex, reportTypeSelector, handleTypeChange) {
    const { dropDownOptions, classes, selectionType } = this.props;
    const chartId = DEVICE_CATEGORY_CHART_ID;
    const dropDownOptionList = Object.values(dropDownOptions);

    return (
      <FormControl className={styles.dropDown}>
        <Select
          value={reportTypeSelector || selectionType}
          className={styles.selector}
          onChange={handleTypeChange(selectorIndex, chartId)}
          inputProps={{ classes: { icon: classes.arrowDropDown } }}
        >
          {
            dropDownOptionList.map(item => (
              <MenuItem
                value={item.key}
                key={item.key}
              >
                {item.label}
              </MenuItem>
            ))
          }
        </Select>
      </FormControl>
    );
  }

  prepChartData(deviceChartSelectorType) {
    const { dropDownOptions, data, selectionType } = this.props;
    const chartSelectorType = deviceChartSelectorType || selectionType;
    const { key, label } = get(dropDownOptions, [chartSelectorType], {});
    const chartData = data.reduce((accum, currentEntry) => {
      const { deviceType } = currentEntry;
        if (deviceType) {
          const value = currentEntry[key] || 0;
          accum.push({ deviceType, value });
        }
        return accum;
    }, []);
    return { chartData, valueLabel: label, valueKey: key };
  }
  
  exportContainer = React.createRef();
  render() {
    const {
      title,
      fileName,
      currentStep,
      inpdf,
      page,
      isCustomize,
      countInReportConfig,
      showInReportConfig,
      isCustomReport,
      data,
      deviceChartSelectors,
      pageNumber,
      tableSortSelector,
      totalAds,
      isHiddenChart,
    } = this.props;
    let isDisplayChart = inpdf ? !isHiddenChart : true;
    const { chartData, valueLabel } = this.prepChartData();
    const { deviceCategoryChart, deviceCategoryTable } = showInReportConfig;
    const { deviceCategoryChart: chartCount, deviceCategoryTable: tableCount } = countInReportConfig;
    const deviceCategoryChartAndTableCount = getNumberOfChartAndTableInReport(chartCount, tableCount);

    const isGrandTotalDisplay = !inpdf || inpdf && page === pageNumber - 1;
    const isFirstPDFPage = !inpdf || (inpdf && page === 0);

    let isDisplayTable = inpdf ? isHiddenChart : true;
    let showDeleteChartButton = false;
    let showDeleteTableButton = false;
    if (isCustomReport) {
      isDisplayChart = isDisplayChart && deviceCategoryChart && isFirstPDFPage;
      isDisplayTable = isDisplayTable && deviceCategoryTable;
      showDeleteChartButton = deviceCategoryChart;
      showDeleteTableButton = deviceCategoryTable;
    }

    return(
      <div className={cx({[styles.deviceCategoryAnalyticsMainView]: !isCustomReport}, styles.deviceCategoryContainer)}>
      {Array(deviceCategoryChartAndTableCount).fill('').map((_item, index) => {
          const prefixKey = chartCount[index] ? deviceCategoryChartId : deviceCategoryTableId;
          const key = chartCount[index] || tableCount[index] || (index + 1);
          const isDisplayChartInPreview = !!chartCount.find(item => item === index + 1) && (inpdf ? !isHiddenChart : true);
          isDisplayChart = isDisplayChartInPreview && isFirstPDFPage;
          isDisplayTable = !!tableCount.find(item => item === index + 1) && (inpdf ? isHiddenChart : true);
          const reportTypeSelector = get(deviceChartSelectors, [index, 'type']);
          const reportData = this.prepChartData(reportTypeSelector);
          const reportChartData  = get(reportData, 'chartData');
          const reportValueLabel = get(reportData, 'valueLabel');
          const isDisplayChartContainer = !inpdf && (isDisplayChart || isDisplayTable) || inpdf && isDisplayChart;
          showDeleteChartButton = isCustomReport && isDisplayChart;
           // calculate number rows of table per page in pdf file
          let rowsPerDevicePage = inpdf
          ? page === 0
            ? (MIN_LENGTH_TRAFFIC_CHANNEL_DATA + 1)
            : (SINGLE_PAGE_WEB_ANALYTICS_DATA + 1)
          : 0;
          // re-calculate tableRowsPerPage if use custom report because of adding description and multiple items
          if (inpdf && isCustomReport) {
            if (!isDisplayChart) {
              rowsPerDevicePage = SINGLE_PAGE_WEB_ANALYTICS_DATA + 1;
            }
            rowsPerDevicePage = rowsPerDevicePage - COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE;
          }
          return (
            <Fragment key={prefixKey+key}>
              {
                isDisplayChartContainer && (
              <Fragment>
                {isDisplayChart &&
                  <ModuleExport
                    exportImg={this.exportContainer}
                    fileName={fileName}
                    disableCsvExport
                  />
                }
                  <div ref={this.exportContainer} className={cx({[styles.deleteItemContainer]: currentStep === isCustomize && isDisplayChart}, styles.itemContainer)} data-test="deciveCategoryChart">
                      {showDeleteChartButton &&
                            <DeleteReportItemButton
                              isDelete={showDeleteChartButton}
                              parentId={deviceCategoryId}
                              componentId={deviceCategoryChartId}
                              customClassName={styles.deleteButton}
                              itemIndex={index}
                            />
                          }
                       {!inpdf && (
                          <div className={styles.header}>
                            <div>{title}</div>
                          </div>
                        )}
                        <div className={styles.containerDropdown}>
                          {this.drawDropDown(index, reportTypeSelector, this.handleTypeChange)}
                        </div>

                        {isDisplayChart &&
                          <div className={styles.contentContainer}>
                            <div className={styles.chartContainer}>
                              <div className={styles.chart}>
                                <DeviceChart
                                  data={reportChartData || chartData}
                                  valueLabel={reportValueLabel || valueLabel}
                                  isPercentageDisabled={false}
                                  isAdVisits
                                />                      
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </Fragment>
                  )
                }
              {isDisplayTable &&
                <div className={cx({[styles.deleteItemContainer]: currentStep === isCustomize}, styles.tableContainer, styles.itemContainer)}>
                  {showDeleteTableButton &&
                    <DeleteReportItemButton
                      isDelete={showDeleteTableButton}
                      parentId={deviceCategoryId}
                      componentId={deviceCategoryTableId}
                      customClassName={styles.deleteButton}
                      itemIndex={index}
                    />
                  }
                  <Table
                    data={data}
                    totalAds={totalAds}
                    page={page}
                    tableColumns={tableColumns}
                    isGrandTotalDisplay={isGrandTotalDisplay}
                    tableSortSelector={tableSortSelector}
                    csvColumns={csvColumns}
                    rowsPerPage={rowsPerDevicePage}
                    numberPage={pageNumber}
                    inpdf={inpdf}
                    itemIndex={index}
                    isCustomReport={isCustomReport}
                    isDisplayChart={deviceCategoryChart}
                  />
                </div>
              }
            </Fragment>
          )
        })}
        </div>   
    )
  }
};

const muiStyle = {
  arrowDropDown: {
    color: '#2196f3'
  }
};

import { setReportChartSelector } from '../../../state/modules/app/reportBuilder/actions';
import { setChartSelector } from '../../../state/modules/app/campaign';

const DeviceCategoryAnalyticsSmartComponent = connect(
  (state, props) => {
    const { chartData, campaign } = props;
    const totalAds = get(chartData, 'totalAds', 0);
    const currentStep = get(state, 'reportBuilder.currentStep', '');
    const data = get(chartData, [DEVICE_CATEGORY_CHART_ID, 'data'], []);
    const selectionType = get(campaign, ['chartSelector', DEVICE_CATEGORY_CHART_ID, 'type'], defaultDataType);
    const deviceChartSelectors =  props.deviceChartSelectors || get(state, ['reportBuilder', 'chartSelector', DEVICE_CATEGORY_CHART_ID], []);

    return {
      data,
      totalAds,
      currentStep,
      selectionType,
      deviceChartSelectors
    }
  },
  {
    setReportChartSelector,
    setChartSelector,
  }
)(withStyles(muiStyle)(DeviceCategory));
export default DeviceCategoryAnalyticsSmartComponent;
